import { type UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/provider';

import { fg } from '@confluence/feature-gating';
import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient.ts';

type GetUsePrefilteredExtensionListOptionsParams = {
	cloudId: string;
	locale: string;
	moduleType: string;
	queryOptions?: any;
	includeHidden: boolean;
	spaceKey?: string;
	contentId?: string;
	attachmentId?: string;
	spaceContextOnly?: boolean;
};

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
	attachmentId,
	spaceContextOnly = false,
}: GetUsePrefilteredExtensionListOptionsParams): UsePreFilteredExtensionsQueryOptions => {
	const includeAttachmentId = attachmentId && fg('forge_attachment_display_conditions');
	const context = spaceContextOnly
		? { spaceKey }
		: { spaceKey, contentId, ...(includeAttachmentId ? { attachmentId } : {}) };

	const options: UsePreFilteredExtensionsQueryOptions = {
		client: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context,
		includeHidden,
	};

	return options;
};
